<div *ngFor="let indication of indicationGroup.indications;">
  <div class="container-fluid" [ngClass]="{ 'pb-2rem': indication.selected }">
    <div class="row" [ngClass]="{ 'box-neon-3': indication.selected }">
      <div class="col-12" [ngClass]="{ 'indication-selection-row': indication.selected }">
        <div class="form-check">
          <kendo-label class="form-check-label rtl" [text]="indication.displayName" 
          [ngClass]="{'search-indication-selection-label': selectedSearchIndication && indication.displayName === selectedSearchIndication.name, 
          'selected-indication-section-label': indication.selected, 
          'indication-switch': !indication.selected}">
            <input class="form-check-input" [hidden]="!indicationGroup.demo && isDemoUser"
              type="checkbox"
              [size]="'large'"
              [rounded]="'medium'"
              kendoCheckBox
              [(ngModel)]="indication.selected"
              (change)="indicationSelectionChange($event)"
              [disabled]="!indicationGroup.demo && isDemoUser"
              #indicationSelection
            />
          </kendo-label>
        </div>
      </div>
      <div *ngIf="indication.selected" class="indication-input-section-bg">
        <div class="container-fluid indication-input-section-pad">
          <div class="row">
            <div class="col-md-8">
              <app-diagnosed-only *ngIf="indication.diagnosedOnly" [indicationDisplayName]="indication.displayName" ></app-diagnosed-only>
              <app-radio-input-group *ngIf="indication.name === 'angina'" [indication]="indication" [labelName]="'Populations to include'" [controlName]="'populations'" [controlDisplayName]="'Populations'"></app-radio-input-group>
              <app-limits-input *ngIf="limitsInput(indication.name)" [indication]="indication"></app-limits-input>
              <app-radio-input-group *ngIf="criteriaInput(indication.name)" [indication]="indication"></app-radio-input-group>
              <app-checkbox-treeview *ngIf="checkboxTreeview(indication.name)" [indication]="indication" [labelName]="indication['controlLabelName'] + ':'"></app-checkbox-treeview>
              <app-asthma *ngIf="indication.name === 'asthma'" [indication]="indication"></app-asthma>
              <app-dyslipidemia *ngIf="indication.name === 'dyslipidemia'" [indication]="indication"></app-dyslipidemia>
              <app-hypertension *ngIf="indication.name === 'hypertension'" [indication]="indication"></app-hypertension>
              <app-diabetes *ngIf="indication.name === 'diabetes'" [indication]="indication"></app-diabetes>
              <app-albumin *ngIf="indication.name === 'albumin'" [indication]="indication"></app-albumin>
              <app-age *ngIf="indication.name === 'age'" [indication]="indication"></app-age>
              <app-metabolicSyndrome *ngIf="indication.name === 'metabolicSyndrome'" [indication]="indication"></app-metabolicSyndrome>
              <app-body-weight *ngIf="indication.name === 'bodyWeight'" [indication]="indication"></app-body-weight>
              <app-ckd *ngIf="indication.name === 'ckd'" [indication]="indication"></app-ckd>
              <app-hepatitis *ngIf="indication.name === 'hepatitis'" [indication]="indication"></app-hepatitis>
            </div>
            <div class="col-md-4">
              <app-indication-definition [definition]="indication.definition"></app-indication-definition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>